import { FC } from 'react';
import { FormControl, MenuItem, Select, styled } from '@mui/material';
import { toString } from 'lodash';
import { IPalette } from 'theme/types';
import { FundSelectorProps } from './FundSelector.props';

const StyledSelect = styled(Select)(({ theme }) => ({
  '&.MuiInputBase-root': {
    background: 'transparent',
  },
  '.MuiSelect-select': {
    color: `${(theme.palette as unknown as IPalette).primary[700]} !important`,
    fontWeight: 'bold',
    paddingTop: theme.spacing(0.75),
    background: 'transparent',
    minWidth: 0,
  },
  '.MuiSelect-icon': {
    marginTop: theme.spacing(0.25),
  },
  '&.Mui-focused .MuiSelect-select': {
    background: 'transparent !important',
  },
}));

const FundSelector: FC<FundSelectorProps> = props => {
  const { handleOnChange, options, value } = props;

  return (
    <FormControl fullWidth>
      <StyledSelect
        disableUnderline
        onChange={e => handleOnChange(toString(e.target.value))}
        value={value}
        variant="standard">
        {options.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};

export default FundSelector;
